export default __webpack_public_path__ + "static/media/empty_connectors.1becd9e7.png";